import { boolean, email, nonOptional, string } from 'valibot';

export const fieldIsRequiredTranslationKey = 'FieldIsRequired';
export const notValidEmailTranslationKey = 'PleaseEnterValidEmailAddress';
export const passwordMustContainAtLeastOneUppercaseLetterTranslationKey =
  'PasswordMustContainAtLeastOneUppercaseLetter';
export const passwordMustContainAtLeastOneNumberTranslationKey =
  'PasswordMustContainAtLeastOneNumber';
export const passwordMustContainAtLeastOneSpecialCharacterTranslationKey =
  'PasswordMustContainAtLeastOneSpecialCharacter';
export const passwordMustHave8CharactersOrMoreTranslationKey = 'PasswordMustHave8CharactersOrMore';

export const stringRequired = () => nonOptional(string(), fieldIsRequiredTranslationKey);
export const emailWrapper = () => email(notValidEmailTranslationKey);
export const booleanRequired = () => nonOptional(boolean(), fieldIsRequiredTranslationKey);
